import api from "../../../api/parametres/_modele-analyses";

const state = () => ({
    modeles_analyses: [],
    current_modele_analyse: null,
});

const getters = {
    modeles_analyses: (state) => {
        return state.modeles_analyses
    },

    current_modele_analyse: (state) => {
        return state.current_modele_analyse
    }
};

const mutations = {
    SET_MODELS_ANALYSES(state, data) {
        state.modeles_analyses = data.sort((a, b) => b.usage_count - a.usage_count)
    },

    SET_CURRENT_MODEL_ANALYSE(state, data) {
        state.current_modele_analyse = data
    }
};

const actions = {
    fetchModelesAnalyses({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.getModelsAnalyses(params).then(
                (response) => {
                    commit("SET_MODELS_ANALYSES", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    deleteModeleAnalyse({ dispatch }, id) {
        return new Promise((resolve, reject) => {
            api.deleteModeleAnalyse(id).then(
                (response) => {
                    dispatch("fetchModelesAnalyses");//TODO: replace by simple remove from list
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    activateDeactivateModeleAnalyse({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.activateDeactivateModeleAnalyse(data.id).then(
                (response) => {
                    dispatch("fetchModelesAnalyses");
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    async saveModeleAnalyse(_, data) {
        return await api.saveModeleAnalyse(data);
    },

    async updateModeleAnalyse(_, data) {
        return await api.updateModeleAnalyse(data.id, data);
    },
    
    setModeleAnalyse({ commit }, model) {
        commit("SET_CURRENT_MODEL_ANALYSE", model);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
